export default class Patient {
  constructor({ 
    id = null, 
    firstName, 
    lastName, 
    email, 
    phone, 
    address,
    rawAddress = '',
    city = '',
    state = '',
    zip = '',
    cityStateZip = '',
    cityState = '',  // Added cityState parameter with default empty string
    dob,
    reason,
    gender,
    race,
    maritalStatus,
    ethnicity,
    income,
    familySize = '0'  // Change default value to string '0' instead of number 0
  }) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.phone = phone;
    this.address = address;
    this.rawAddress = rawAddress;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.cityStateZip = cityStateZip;
    this.cityState = cityState;  // Store the cityState value
    this.dob = dob;
    this.reason = reason;
    this.gender = gender;
    this.race = race;
    this.maritalStatus = maritalStatus;
    this.ethnicity = ethnicity;
    this.income = income;
    this.familySize = familySize;  // Will store as string
    this.age = Patient.calculateAge(dob);
  }
  
  static calculateAge(dob) {
    if (!dob) return null;
    const birthday = new Date(dob);
    const diff = Date.now() - birthday.getTime();
    const ageDate = new Date(diff);
    return String(Math.abs(ageDate.getUTCFullYear() - 1970)); // Convert to string
  }
  
    // Check if patient is 18 or older
    static isAdult(dob) {
      const age = this.calculateAge(dob);
      return age !== null && parseInt(age, 10) >= 18; // Parse string age for comparison
    }
  
    // Convert the patient to a plain object for Firebase
    toJSON() {
      return {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
        address: this.address,
        rawAddress: this.rawAddress,
        city: this.city,
        state: this.state,
        zip: this.zip,
        cityStateZip: this.cityStateZip,
        cityState: this.cityState,  // Include cityState in JSON output
        dob: this.dob,
        reason: this.reason,
        gender: this.gender,
        race: this.race,
        maritalStatus: this.maritalStatus,
        ethnicity: this.ethnicity,
        income: this.income,
        familySize: this.familySize,  // Include familySize in JSON output
        age: this.age, 
      };
    }
  
  static fromJSON(data, id = null) {
    return new Patient({ id, ...data });
  }
  
  static fromFormData(basicInfo, demographics) {
    return new Patient({
      ...basicInfo,
      ...demographics
    });
  }
}
